<template>
  <div>
    <TreeSelect :value="value" :searchWord="searchWord" :data="data" @open="loadChildNodes" @input="itemSelected" ref="treeSelect" v-if="data">
      <template slot-scope="{ item, on }">
        <template v-if="item !== data">
          <LimitLeaf v-if="item.item.type === 'limit-100-leaf'" />
          <DPDLeaf :class="{ clickable: item.item.type || item.item.id === 'searchWord' }" :item="item.item" :searchWord="searchWord" v-on="on" v-else />
        </template>
      </template>
    </TreeSelect>
    <div class="p-2" v-else>
      <LoadingLeaf v-if="isLoading" />
      <div v-else>
        <div class="vue-treeselect__icon-container pl-1">
          <span class="vue-treeselect__icon-warning"></span>
        </div>
        <span class="vue-treeselect__tip-text vue-treeselect__no-results-tip-text">
          <template v-if="!shouldSearch">Type at least 4 characters to search by keyword</template>
          <template v-else-if="searchWord">No results found...</template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../../../axios';
import eqNode from 'eqnode';
import { Debouncer, errorDebug } from '../../../../libraries/common';
import { loadChildNodes, createSearchId, createRootData, filterTags, findDPDItem } from '../../../../libraries/dpdSearch';

import TreeSelect from '../../treeselect/TreeSelect.vue';
import LoadingLeaf from '../../treeselect/LoadingLeaf.vue';
import DPDLeaf from './DPDLeaf.vue';
import LimitLeaf from './LimitLeaf.vue';

export default {
  noExport: true,
  components: { TreeSelect, LoadingLeaf, DPDLeaf, LimitLeaf },
  props: ['value', 'title', 'label', 'placeholder', 'categorySettings', 'tags', 'searchWord', 'data'],
  data() {
    return {
      showDropDown: false,
      isLoading: false,
      cancelRequest: null,
      searchDebouncer: new Debouncer(100),
    };
  },
  computed: {
    shouldSearch() {
      return this.searchWord?.length > 3;
    },
    valueText() {
      return this.value?.label;
    },
  },
  methods: {
    searchWordChanged() {
      this.$emit('update:data', null);
      this.isLoading = this.shouldSearch;
      if (this.cancelRequest)
        this.cancelRequest();
      this.searchDebouncer.clear()
        .push(() => {
          this.$emit('update:data', null);
          if (this.shouldSearch) {
            this.isLoading = true;
            var query = this.searchWord;
            axios.get('/Analytics/Cohort/CriteriaSearch', {
              params: { query, ...this.categorySettings },
              cancelToken: new axios.CancelToken(c => this.cancelRequest = c)
            })
              .then(({ data }) => {
                this.$emit('update:data', eqNode.fromObject({
                  children: [
                    { label: query, id: 'searchWord' },
                    ...createRootData({
                      ...data,
                      Tags: filterTags(this.tags, query),
                    }),
                  ]
                }).forEach(f => f.item.search = f.item.search || createSearchId(f)));

                if (this.data) {
                  var openSingleResult = item => {
                    this.$nextTick(() => {
                      this.$refs.treeSelect.setStateOpen({ item, open: true });
                      this.$refs.treeSelect.treeStateZoomItem(item);
                      this.loadChildNodes(item)
                        .then(() => {
                          if (item.children.length === 1)
                            openSingleResult(item.children[0]);
                        });
                    })
                  }
                  var withIdChildren = this.data?.toArray().filter(f => f.id && f.id !== 'searchWord');
                  if (withIdChildren?.length === 1) {
                    openSingleResult(this.data.find(f => f.item === withIdChildren[0]))
                  }
                }
              })
              .then(() => this.isLoading = false)
              .catch(error => {
                if (!axios.isCancel(error)) {
                  errorDebug(error);
                  this.isLoading = false;
                }
              });
          }
        });
    },
    loadChildNodes(item) {
      return loadChildNodes(item, this.searchWord)
        .then(() => this.$emit('update:data', this.data));
    },
    itemSelected(item) {
      if (item.item.type || item.item.id === 'searchWord') {
        this.$emit('input', item.item);

        if (item.item.id !== 'searchWord') {
          this.$emit('update:data', null);
        }
      }
    },
    removeItem(item) {
      this.$emit('input', this.value.toggle(item));
    },
    isSelected(item) {
      return findDPDItem(this.value, item.item.search);
    },
  },
  watch: {
    searchWord() {
      this.searchWordChanged();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDPDSearchSingleTree'] = this;
  },
}
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  // padding: 5px 16px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
}
</style>